module.exports = __webpack_public_path__ + "img/download.c8633f42.svg";